import { ChangeEvent, useState } from 'react';
import { Box, paletteColors, Switch, TextField, Typography } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

type TaskCommentSectionProps = {
    comment: string;
    onCommentChange: (comment: string) => void;
};

export const TaskCommentSection = ({ comment, onCommentChange }: TaskCommentSectionProps) => {
    const { formatMessage } = useIntl();
    const [checked, setChecked] = useState<boolean>(!!comment);

    const handleSwitchClick = () => {
        setChecked((previous) => !previous);
        if (checked) {
            onCommentChange('');
        }
    };

    const handleCommentChange = (event: ChangeEvent<HTMLInputElement>) => {
        onCommentChange(event.target.value);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                padding: '12px',
                border: `1px solid ${paletteColors.neutral[300]}`,
                borderTop: 'none',
                borderBottomLeftRadius: '4px',
                borderBottomRightRadius: '4px',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                }}
            >
                <Typography
                    component="label"
                    htmlFor="include-comment-switch"
                    variant="body2"
                    sx={{
                        fontWeight: 700,
                        cursor: 'pointer',
                    }}
                >
                    {formatMessage({ id: 'dossier.task.include_comment' })}
                </Typography>
                <Switch
                    id="include-comment-switch"
                    checked={checked}
                    onClick={handleSwitchClick}
                    size="small"
                    color="primary"
                />
            </Box>
            {checked && (
                <TextField
                    multiline
                    autoFocus
                    rows={3}
                    value={comment}
                    onChange={handleCommentChange}
                    placeholder={formatMessage({ id: 'dossier.task.add_comment_placeholder' })}
                    size="small"
                    fullWidth
                    slotProps={{
                        htmlInput: {
                            maxLength: 100,
                        },
                    }}
                    sx={{
                        '& .MuiInputBase-root': {
                            typography: 'body2',
                        },
                        '& .MuiInputBase-input::placeholder': {
                            typography: 'body2',
                            color: paletteColors.neutral[400],
                            opacity: 1,
                        },
                    }}
                />
            )}
        </Box>
    );
};
